module.exports = __webpack_public_path__ + "static/podcast-4f8192e589ea46dd501149707899d0ff.png";